import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { CheckboxListComponent } from "@components/checkbox-list/checkbox-list.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { Observable, of } from "rxjs";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-transporttilldelad-filter",
    templateUrl: "./tpl-transporttilldelad-filter.component.html",
    styleUrls: ["./tpl-transporttilldelad-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxListComponent
    ]
})
export class TplTransporttilldeladFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {

    options: Observable<string[]>;

    constructor() {
        super("transporttilldelad");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    onFilterInit(state: string[]): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    match(item: ITplArbetsorder): boolean {
        const value = this.value();
        const expectTransporttilldelad = value.some(x => x === "Ja");
        const expectNotTransporttilldelad = value.some(x => x === "Nej");
        const handelssortimentMedBefraktare = item.handelssortiment.find(x => x.befraktareId != null);

        const isTransporttilldelad = !!(item.transportforetagId || handelssortimentMedBefraktare);
        return (expectTransporttilldelad && isTransporttilldelad) || (expectNotTransporttilldelad && !isTransporttilldelad);
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: string[]): void {
        this.filterLength = !value ? 0 : value.length;
    }

    private initOptions(): void {
        const options = [
            "Ja",
            "Nej"
        ];
        this.options = of(options);
    }
}
